import { create } from "zustand";

interface LegacyHdBridgeStore {
  sendToLegacy: ((message: object) => void) | null;
  register: (fn: (message: object) => void) => void;
}

export const useLegacyHdBridgeStore = create<LegacyHdBridgeStore>((set) => ({
  sendToLegacy: null,
  register: (fn) => set({ sendToLegacy: fn }),
}));
